<template>
    <multiselect v-model="selectedStatus" :options="statusList" :multiple="true" label="name" track-by="name"
                 placeholder="Type to search for pay status" open-direction="bottom" :searchable="true"
                 @input="updateValue"></multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    name: 'AssignmentStatusSelect',
    components: { Multiselect },
    props: {
        statusList: {
            type: Array,
            required: true,
        },
    },
    data () {
        return {
            selectedStatus: [],
        }
    },
    methods: {
        updateValue (options) {
            const statuses = options.map(option => option.name)
            this.$emit('input', statuses)
        },
        clear() {
            this.selectedStatus = [];
            this.$emit('input', []);
        },
    },
}
</script>

<style scoped>

</style>
